import { render, staticRenderFns } from "./vue-file-list.vue?vue&type=template&id=5ef04e06&"
import script from "./vue-file-list.vue?vue&type=script&lang=ts&"
export * from "./vue-file-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports